import DocumentGatewayInterface from '../../domain/Document/DocumentGatewayInterface';
import Caller from "../../domain/Api/Caller";
import envVariable from "../../presentation/util/envVariable";
import storage from '../../presentation/util/storage';
import Receipt from '../../domain/Receipt/Receipt';
import GeneratedDocument from '../../domain/Document/GeneratedDocument';

export default class FetchDocumentGateway implements DocumentGatewayInterface {

  send(blockId: string, documents: Document[], folderId?: string): Promise<Receipt[]|null> {
    const effectiveFolderId = folderId ?? storage.getFolderId();
    return Caller.executePut(`${envVariable('REACT_APP_API_URL')}/dossiers/${effectiveFolderId}/receipts`, {
      submittingBlockId: blockId,
      receipts: documents
    })
      .then(data => {
        if (!data) {
          return null
        }

        const receipts: Receipt[] = []
        data.dossier.receipts.map(receipt => {
          receipts.push(new Receipt(receipt.receiptId, receipt.typeId, receipt.elementId, receipt.title, receipt.resource))
        })

        return receipts
      }).catch(() => {
        return null
      })
  }

  async getGeneratedDocuments(blockId: string, folderId?: string): Promise<GeneratedDocument[]|null> {
    const effectiveFolderId = folderId ?? storage.getFolderId();
    return Caller.executePost(`${envVariable('REACT_APP_API_URL')}/dossiers/${effectiveFolderId}/documents/list`, {
      block_id: blockId
    })
      .then(data => {
        if (!data) {
          return null
        }

        const documents: GeneratedDocument[] = []
        data.documents.map((doc) => {
          documents.push(new GeneratedDocument(doc.id, doc.filename))
        })

        return documents
      })
  }

  async getGeneratedDocumentById(id: number, folderId?: string): Promise<Blob|null> {
    const effectiveFolderId = folderId ?? storage.getFolderId();
    return Caller.executePostBinaryFile(`${envVariable('REACT_APP_API_URL')}/dossiers/${effectiveFolderId}/preview`, {
      documentId: id,
      save: false
    })
      .then(response => {
        if (!response.data) {
          return null
        }

        return response.data;
      })
  }

  async getGeneratedDocumentsAsArchive(blockId: string, folderId?: string): Promise<Blob|null> {
    const effectiveFolderId = folderId ?? storage.getFolderId();
    return Caller.executePostBinaryFile(`${envVariable('REACT_APP_API_URL')}/dossiers/${effectiveFolderId}/documents/all`, {
      block_id: blockId
    })
      .then(response => {
        if (!response.data) {
          return null
        }
        return response.data;
      })
      .catch(() => {
        return null
      })
  }
}
